<template>
    <Button @click.native="moveDown" :disabled="isDisabled" class="btn-sm d-flex align-items-center gap-2">
        <i class="bi bi-chevron-down"></i>
        Move down
    </Button>
</template>

<script>
import Button from "../../common/Button.vue"

export default {
    name: "PageEditorSectionMoveDownBtn",
    components: {Button},
    computed: {
        pageEditor() {
            return this.$store.state.pageEditor
        },
        isDisabled() {
            return this.pageEditor.pageSections.map(o => o.id)
                    .indexOf(this.pageEditor.activeSectionId) === this.pageEditor.pageSections.length - 1
                || this.pageEditor.moveInProgress

        }
    },
    methods: {
        moveDown() {
            this.$store.dispatch('pageEditor/moveSectionDown')
        }
    }
}
</script>

<style scoped>

</style>